import { render, staticRenderFns } from "./TotalEvaluateEntity.vue?vue&type=template&id=a0b24208&scoped=true"
import script from "./TotalEvaluateEntity.vue?vue&type=script&lang=js"
export * from "./TotalEvaluateEntity.vue?vue&type=script&lang=js"
import style0 from "./TotalEvaluateEntity.vue?vue&type=style&index=0&id=a0b24208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b24208",
  null
  
)

export default component.exports